export const fr = {
  landing: {
    page_title: "Ressources Autour de Moi",
    find_support_across_canada: "Trouver du soutien partout au Canada",
    page_description:
      "Choisir un emplacement pour rechercher des programmes et services de soutien physiques ou virtuels pour les jeunes, les adolescents et les adultes de partout au Canada!",
    location_field_error: "S'il vous plaît entrez un emplacement",
    use_current_location: "Utiliser mon emplacement actuel",
  },
  searchType: {
    search_by_label: "Rechercher par",
    search_tips_link: "Astuces de recherche",
    support_type__radio_label: "Type de soutien",
    keyword__radio_label: "Mot-clé",
  },
  supportType: {
    dropdown_label: "Choisir le type de soutien",
    dropdown_default_value: "Choisir",
    narrow_down__dropdown_label: "Limiter les choix par type de soutien",
    narrow_down__dropdown_default_value: "Limiter les choix",
    submit_button: "Trouver des programmes et services de soutien",
    read_more_topic_text: "Découvrir les aides pour quitter le foyer d'accueil",
    read_more_topic_link: "https://jeunessejecoute.ca/information/soutien-pour-les-jeunes-des-premieres-nations-inuits-et-metis",
  },
  searchByKeyword: {
    search_by_keyword_label: "Rechercher par mot-clé",
    input_placeholder:"Exemple : refuge pour les jeunes",
    modal_title:
      "Pour tous ceux qui pourraient avoir des pensées suicidaires, il est possible d'obtenir de l'aide et de trouver l'espoir.",
    modal_description:
      "Jeunesse, J’écoute compte sur une équipe d'intervenants cliniques et de Répondants aux crises qui peuvent t'aider. Il est possible de nous contacter par :",
    modal_callus_btn: "Téléphone",
    modal_textus_btn: "Texto",
    modal_continue_search: "Retour aux résultats de recherche",
    submit_button: "Trouver des programmes et services de soutien",
    keyword_1: "suicide",
    keyword_2: "me tuer",
    keyword_3: "je veux mourir",
  },
  searchPageHeader: {
    results: "Résultats",
    showing_keyword_results: "Affichage des résultats pour les mots-clés :",
    search_result_with: "Résultats de recherche avec",
    of: "de",
    items: "éléments",
    favourites: "Favoris",
    edit_search: "Modifier la recherche",
    add_to_favorite_tooltip: "Ajouté à vos Favoris",
    removed_from_favorites_tooltip: "Supprimé de vos Favoris",
    go_to_fav: "Accéder à votre liste de favoris avec",
    item:"élément",
  },
  searchResult: {
    no_result_found: "Aucun résultat trouvé.",
  },
  searchItem: {
    add_to_favorite: "Ajouter à votre liste de favoris",
    addeed_to_favorite_wcag: "Ajouté à vos Favoris",
    remove_from_favorite_wcag:
      "Supprimé de vos Favoris",
    result: "Résultats",
    of: "de",
    resource_type: "Type de ressource",
    website: "Consulter le site Web",
    new_tab: "ouvrir dans un nouvel onglet",
    view_more_details: "Afficher des informations supplémentaires",
    hotline:"Ligne d'assistance",
    physical_location:"Localisation physique",
    more_details:"Plus de détails"
  },
  resourcedetails: {
    add_to_favorite: "Ajouter à vos Favoris",
    open_hours: "Heures d'ouverture",
    remove_from_favourites: "Supprimé de vos Favoris",
    add_to_favorite_tooltip: "Ajouté à vos Favoris",
    removed_from_favorites_tooltip: "Supprimé de vos Favoris",
    favourites: "Favoris",
    back: "retour",
    goto_fav_list: "Accéder à votre liste de favoris",
    call: "Appeler",
    website: "Consulter le site Web",
    new_tab: "ouvrir dans un nouvel onglet",
    about_us: "À propos de nous",
    details: "Détails",
    cost:"Coût",
    age_limit: "Limite d'âge",
    eligibility: "Admissibilité",
    accessibility: "Accessibilité",
    languages_offered: "Langues disponibles",
    wait_times: "Délais d'attente",
    application_process: "Processus d'application",
    documents_required: "Documents requis",
    coverage_area: "Zone desservie",
    visit_website: "Consulter le site Web ",
    back_to_search_results: "Retour aux résultats de recherche",
    get_directions: "S'orienter",
  },
  ramFooter: {
    new_tab: "ouvrir dans un nouvel onglet",
    search_tips: "Astuces de recherche",
    ram_faq: "FAQ sur Ressources Autour de Moi",
    what_you_think: "Partage ton opinion au sujet de cet outil",
    user_experience:
      "Partage ton expérience sur cet outil avec ce sondage.",
  },
  map: {
    no_results: "Vos résultats de recherche n'ont pas de sites physiques",
  },
  loader: {
    title: "Un instant... nous cherchons des ressources qui pourraient s'avérer utiles...",
    searching_for: "Recherche de",
    in: "dans",
  },
  favoriteItem: {
    open_hours: "Heures d'ouverture",
    phone: "Téléphone",
    details: "Détails",
    website: "Consulter le site Web",
    cost: "Coût",
    age_limit: "Limite d'âge",
    eligibility: "Admissibilité",
    accessibility: "Accessibilité",
    languages_offered: "Langues disponibles",
    wait_times: "Délais d'attente",
    application_process: "Processus d'application",
    documents_required: "Documents requis",
    coverage_area: "Zone desservie",
    remove_from_favourites: "Supprimé de vos Favoris",
    about: "À propos",
  },
  favorite: {
    email_sent: "Votre courriel a été envoyé.",
    invalid_captcha: "Invalid Captcha.",
    error: "Erreur.",
    enter_emails: "Le champ pour l'adresse courriel ne peut être laissé vide.",
    favourites: "Favoris",
    page_title: "Favoris",
    page_description:
      "Cette page montre les programmes et services de soutien ajoutés à vos Favoris au cours de vos recherches. Cette liste ne sera pas sauvegardée au moment de quitter l'outil ou de fermer l'onglet/la fenêtre.",
    email_list: "Envoyer la liste par courriel",
    get_pdf: "Obtenir le PDF",
    clear_list: "Effacer la liste",
    back_to_results: "Retour aux résultats de recherche",
    no_result: "Aucun résultat trouvé",
    modal_title: "Inscrire ton courriel",
    modal_description:
      "Envoie par courriel les ressources que tu as ajouté à tes favoris ! Ajoute les adresses courriel si-dessous, séparées par une virgule. Ensuite, appuie sur envoyer!",
    modal_input_label: "Inscrire ton courriel",
    modal_email_input_placeholder:"Inscrire ton courriel",
    send_email: " Envoyer un courriel",
    removed_from_favorites_tooltip: "Supprimé de vos Favoris",
    close:"Fermer",
    back:"Retour"
  },
  dropdown: {
    clear_all_filter: "Effacer tous les critères",
    resources_include: "Les ressources comprennent",
    languages_offered: "Langues disponibles",
    communities_supported: "Les ressources comprennent",
    accessibility: "Accessibilité",
    cost: "Coût",
  },
  filters: {
    resources_include: "Les ressources comprennent",
    languages_offered: "Langues disponibles",
    languages_offered_title: "Langues disponibles",
    communities_supported: "Communautés soutenues",
    accessibility: "Accessibilité",
    cost: "Coût",
    show_all: "Tout Afficher",
    show_results: "Afficher les résultats",
    cancel: "Annuler",
    physical_location: "Localisation physique",
    helplines: "Lignes d'assistance téléphonique",
    online_services: "Services en ligne",
    filter: "Filter",
    selected: "sélectionné",
    close:"Fermer",
  },
  app:{
    error_description:"Un problème est survenu. Veuillez réessayer.",
  },
  mapViewController:{
    list_view:"Vue d'ensemble",
    map_view:"Vue de la carte",
    clear_filters:"Effacer tous les critères",
  }
};
